import {
  EnvelopeAllovedActions,
  EnvelopeFlowState,
  FlowStageState,
  TasksStatus,
} from '@const/consts';
import { ICurrentEnvelope, IEnvelopeTasks } from '@store/modules/envelopes/types';

export const getEnvelopeTaskForDecline = (
  envelope: ICurrentEnvelope | null | undefined
): IEnvelopeTasks | null => {
  if (
    !envelope?.currentUserTaskOguid ||
    envelope.flowState !== EnvelopeFlowState.IN_PROGRESS
  ) return null;

  const task = envelope.flow
    .filter(({ state }) => state === FlowStageState.IN_PROGRESS)
    .flatMap(({ tasks }) => tasks)
    .find(({ oguid }) => oguid === envelope.currentUserTaskOguid);

  if (!task || task.state !== FlowStageState.IN_PROGRESS) return null;

  const action = task.type === TasksStatus.SIGNING
    ? EnvelopeAllovedActions.DECLINE_SIGN
    : task.type === TasksStatus.APPROVAL
      ? EnvelopeAllovedActions.DECLINE_APPROVE
      : null;

  return action && envelope.allowedActions.includes(action) ? task : null;
};
